import { render, staticRenderFns } from "./StatusPage.vue?vue&type=template&id=cb39ba6e&scoped=true&"
import script from "./StatusPage.vue?vue&type=script&lang=js&"
export * from "./StatusPage.vue?vue&type=script&lang=js&"
import style0 from "./StatusPage.vue?vue&type=style&index=0&id=cb39ba6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb39ba6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
